import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class HttpQueriesService {

   //private server = 'http://127.0.0.1/congressmc_server/public/';
   private server = 'http://www.congressmc.ma/congressmc_server/public/';
   private url = this.server + 'utilities.php/';
 
   constructor(private http:HttpClient) { 
 
   }
 
   getServer(){
     return this.server;
   }
 
   registerCongresMember(data){
     let dataUrl = this.url+'addcongresmember'; 
     return this.http.post(dataUrl, data);
   }
 
   congresLogin(data){
     let dataUrl = this.url+'congreslogin'; 
     return this.http.post(dataUrl, data);
   }
 
   getStandData(data){
     let dataUrl = this.url+'getStandData'; 
     return this.http.post(dataUrl, data);
   }
 
   saveHallView(data){
     let dataUrl = this.url+'saveHallView'; 
     return this.http.post(dataUrl, data);
   }
 
   saveStandView(data){
     let dataUrl = this.url+'saveStandView'; 
     return this.http.post(dataUrl, data);
   }
 
   getConferences(data){
     let dataUrl = this.url+'conferences/all'; 
     return this.http.post(dataUrl, data);
   }
 
   getConfData(data){
     let dataUrl = this.url+'/conference/byid'; 
     return this.http.post(dataUrl, data);
   }
 
   getStandQuiz(data){
     let dataUrl = this.url+'/standquiz'; 
     return this.http.post(dataUrl, data);
   }
 
   saveStandQuizAnswers(data){
     let dataUrl = this.url+'/standquizsaveanswers'; 
     return this.http.post(dataUrl, data);
   }
 
   getAllStands(){
     let dataUrl = this.url+'stands/all'; 
     return this.http.get(dataUrl);
   }
 
   saveStandData(data){
     let dataUrl = this.url+'stands/add'; 
     return this.http.post(dataUrl, data);
   }
 
   addStandDoc(data){
     let dataUrl = this.url+'document/add'; 
     return this.http.post(dataUrl, data);
   }
 
   addStandProd(data){
     let dataUrl = this.url+'product/add'; 
     return this.http.post(dataUrl, data);
   }
 
   addStandVid(data){
     let dataUrl = this.url+'video/add'; 
     return this.http.post(dataUrl, data);
   }
 
   findUserByEmailCongres(data){
     let dataUrl = this.url+'user/email'; 
     return this.http.post(dataUrl, data);
   }
 
   addStandContact(data){
     let dataUrl = this.url+'contact/add'; 
     return this.http.post(dataUrl, data);
   }
 
   vcSendMailToChangePass(data){
     let dataUrl = this.url+'vcaccount/changepass'; 
     return this.http.post(dataUrl, data);
   }
 
   vcChangePassExec(data){
     let dataUrl = this.url+'vcaccount/changepass/exec'; 
     return this.http.post(dataUrl, data);
   }
 
   vcDeleteDoc(data){
     let dataUrl = this.url+'vcdocument/delete'; 
     return this.http.post(dataUrl, data);
   }
 
   vcDeleteProd(data){
     let dataUrl = this.url+'vcproduct/delete'; 
     return this.http.post(dataUrl, data);
   }
 
   vcDeleteVideo(data){
     let dataUrl = this.url+'vcvideo/delete'; 
     return this.http.post(dataUrl, data);
   }
 
   vcDeleteContact(data){
     let dataUrl = this.url+'vccontact/delete'; 
     return this.http.post(dataUrl, data);
   }
 
   requestAccessActVid(data){
     let dataUrl = this.url+'requestAccessActVid'; 
     return this.http.post(dataUrl, data);
   }

   requestAttestation(data){
    let dataUrl = this.url+'request/attestation'; 
    return this.http.post(dataUrl, data);
  }
}
